<div id="workforceContainer" class="tw-h-screen tw-w-full tw-flex">
  <mat-sidenav-container class="tw-flex-1 tw-h-full" autosize>
    <mat-sidenav-content class="tw-@container">
      <!-- Sticky filters row (hidden by default, shown when regular filters are out of view) -->
      <div
        id="sticky-filters"
        class="tw-sticky tw-top-0 tw-z-20 tw-bg-gray-900 tw-px-4 tw-pt-4 tw-pb-3 @lg:tw-pr-12 @2xl:tw-pr-20"
        style="box-shadow: 0 6px 20px rgba(127, 255, 212, 0.25);"
        *ngIf="showStickyFilters">
        <div class="tw-flex tw-gap-8 tw-items-center tw-justify-center @sm:tw-justify-start">
          <!-- names in company mode -->
          <ng-container
            *ngTemplateOutlet="companyDisplay; context: { isMobile: false }"></ng-container>

          <app-date-range-picker
            [startRange]="dateRangeStrings"
            (selectedDateRange)="onDateRangeChanged($event)"></app-date-range-picker>

          <!-- filter controls on desktop -->
          <div class="tw-gap-2 tw-hidden @xl:tw-flex">
            <ng-container *ngTemplateOutlet="filterControlsTemplate"></ng-container>
          </div>

          <!-- Filter chips for small screens -->
          <div
            class="tw-flex tw-gap-2 @xl:tw-hidden tw-cursor-pointer"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="filtersMenu">
            <ng-container *ngTemplateOutlet="filterChipsTemplate"></ng-container>
          </div>

          <!-- Floating share button for iPad+ screens-->
          <!-- Share hidden for now
<app-share-this-view
            [alwaysHideLabel]="true"
            (shareClick)="onShareClick()"
            class="tw-hidden @md:tw-block tw-ml-auto"></app-share-this-view>
          -->
        </div>
      </div>

      <!-- main content container -->
      <div
        class="tw-flex tw-flex-col tw-gap-1 tw-p-4 tw-py-6
        @lg:tw-px-14 @xl:tw-px-16 @2xl:tw-px-20">
        <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <!-- Share hidden for now
<app-share-this-view
            (shareClick)="onShareClick()"
            class="tw-ml-auto"></app-share-this-view>
          -->
        </div>

        <div
          class="tw-mb-2 @md:tw-mb-4 tw-flex tw-justify-center"
          *ngIf="isPalMode && al_created_at">
          <app-alert
            alertType="info"
            [hasBorder]="false"
            [closeable]="false"
            [hideIcon]="true"
            class="tw-w-full @2xl:tw-w-6/12 @2xl:tw-min-w-[1300px]">
            <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-between tw-items-center">
              <div class="tw-flex tw-flex-col tw-gap-2">
                <div class="tw-text-base @md:tw-text-lg @lg:tw-text-xl">
                  You're only seeing a static snapshot of data taken on
                  {{ al_created_at | date:'MMMM d, yyyy' }}.
                </div>
                <div class="tw-hidden @md:tw-block tw-text-sm tw-text-gray-300">
                  To unlock full live data functionality and see all the people behind the charts,
                  please join our free beta.
                </div>
              </div>
              <button
                class="tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-base @md:tw-text-lg tw-font-medium tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-text-white tw-text-gray-900 dark:tw-text-white tw-p-0.5">
                <span
                  class="tw-relative tw-px-5 tw-py-2 tw-bg-gray-900 tw-text-white tw-rounded-md">
                  Join Free Beta
                </span>
              </button>
            </div>
          </app-alert>
        </div>

        <!-- mode switch -->
        <div class="tw-w-full tw-flex tw-justify-center tw-mb-4 @md:tw-mb-8">
          <div
            class="mode-switch tw-flex tw-gap-2 tw-items-center tw-rounded-full tw-text-sm tw-font-medium tw-border tw-border-solid tw-border-gray-600 tw-bg-gray-700
                  tw-w-full @md:tw-w-11/12 @mdx:tw-w-10/12 @lg:tw-w-9/12 @2xl:tw-w-8/12 tw-h-[56px]"
            tourAnchor="mode-switch">
            <button
              id="workforce-insights-mode-company"
              (click)="setMode('company')"
              class="tw-px-2 tw-py-2 tw-rounded-full tw-h-[58px] tw-w-1/3"
              [ngClass]="{
                          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': mode === 'company',
                          'tw-text-white': mode !== 'company'
                          }">
              <span class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                <mat-icon class="tw-text-[22px] tw-leading-[22px]">business</mat-icon>
                <span class="tw-hidden @md:tw-inline">In Depth</span>
              </span>
              <div class="tw-text-xs tw-hidden @lg:tw-block">Single company analysis</div>
            </button>
            <button
              id="workforce-insights-mode-battle"
              (click)="setMode('battle')"
              class="tw-px-2 tw-py-2 tw-rounded-full tw-h-[58px] tw-w-1/3"
              [ngClass]="{
                          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': mode === 'battle',
                          'tw-text-white': mode !== 'battle'
                          }">
              <span class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                <svg
                  [ngClass]="{
                              'tw-fill-[#7FFFD4]': mode === 'battle',
                              'tw-fill-white': mode !== 'battle'
                              }"
                  height="22"
                  viewBox="0 -960 960 960"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m762-96-117-116-88 88-28-28q-23-23-23-57t23-57l169-169q23-23 57-23t57 23l28 28-88 88 116 117q12 12 12 28t-12 28l-50 50q-12 12-28 12t-28-12zm118-628-454 454 5 4q23 23 23 57t-23 57l-28 28-88-88-117 116q-12 12-28 12t-28-12l-50-50q-12-12-12-28t12-28l116-117-88-88 28-28q23-23 57-23t57 23l4 5 454-454h160zm-546 141 24-23 23-24-23 24zm-56 57-198-198v-160h160l198 198-57 56-174-174h-47v47l174 174zm92 199 430-430v-47h-47l-430 430zm0 0-24-23-23-24 23 24z" />
                </svg>
                <span class="tw-hidden @md:tw-inline">Head to Head</span>
              </span>
              <div class="tw-text-xs tw-hidden @lg:tw-block">Compare companies side-by-side</div>
            </button>
            <button
              (click)="setMode('benchmark')"
              class="tw-px-2 tw-py-2 tw-rounded-full tw-h-[58px] tw-w-1/3"
              [ngClass]="{
                          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': mode === 'benchmark',
                          'tw-text-white': mode !== 'benchmark'
                          }">
              <span class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                <mat-icon class="tw-text-[22px] tw-leading-[22px]">leaderboard</mat-icon>
                <span class="tw-hidden @md:tw-inline">Benchmark</span>
                <h4 class="tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-mb-0 tw-mt-0">
                  <span
                    class="tw-inline-flex tw-items-center tw-rounded-md tw-leading-4 tw-text-sm tw-font-semibold tw-text-blue-500 tw-ring-1 tw-ring-inset tw-ring-blue-500 tw-px-2 tw-pb-1">
                    beta
                  </span>
                </h4>
              </span>
              <div class="tw-text-xs tw-hidden @lg:tw-block">Compare vs peer cohort</div>
            </button>
          </div>
        </div>

        <!-- Company list editor iPad+ -->
        <app-company-list-editor
          tourAnchor="company-list"
          [multiSelect]="selectMultipleCompanies"
          [initialActiveList]="activeList"
          (activeListChange)="onActiveListChange($event)"
          [initialSelectedCompanyIds]="selectedCompanyIds"
          (selectedCompaniesChange)="onSelectedCompaniesChange($event)"
          class="tw-hidden @md:tw-flex"></app-company-list-editor>

        <!-- company name in company mod on mobile -->
        <ng-container
          *ngTemplateOutlet="companyDisplay; context: { isMobile: true }"></ng-container>

        <!-- filters -->
        <div #regularFilters class="controls-container" tourAnchor="dropdowns-wrapper">
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-pt-1 tw-mb-8">
            <app-date-range-picker
              [startRange]="dateRangeStrings"
              (selectedDateRange)="onDateRangeChanged($event)"></app-date-range-picker>

            <!-- mobile -->
            <button
              #filtersMenuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="filtersMenu"
              class="tw-flex @md:tw-hidden tw-gap-2 tw-cursor-pointer"
              (click)="$event.stopPropagation()">
              <ng-container *ngTemplateOutlet="filterChipsTemplate"></ng-container>
            </button>

            <span class="tw-hidden @md:tw-flex tw-ml-4">Filters:</span>

            <!-- Job Function Chip (desktop) -->
            <app-job-function-dropdown
              [useChipDisplay]="true"
              [multiSelect]="true"
              [preSelectedJobFunctions]="selectedJobFunctions"
              (jobFunctionSelectionChanged)="onJobFunctionSelectionChanged($event)">
            </app-job-function-dropdown>

            <!-- Job Level Chip (desktop) -->
            <app-job-level-dropdown
              [useChipDisplay]="true"
              [multiSelect]="true"
              [preSelectedJobLevels]="selectedJobLevels"
              (jobLevelSelectionChanged)="onJobLevelSelectionChanged($event)">
            </app-job-level-dropdown>

            <!-- Role Chip (desktop) -->
            <app-role-dropdown
              [useChipDisplay]="true"
              [preSelectedRole]="selectedRole"
              (roleSelected)="onRoleSelect($event)">
            </app-role-dropdown>
          </div>
        </div>

        <!-- Empty state message -->
        <div
          *ngIf="selectedCompanyIds.size === 0"
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-lg tw-p-8 tw-my-8 tw-text-center">
          <mat-icon class="tw-text-gray-500">business</mat-icon>
          <h3 class="tw-text-xl tw-font-medium tw-text-white tw-mt-4 tw-mb-0">
            No Companies Selected
          </h3>
          <p class="tw-text-gray-400 tw-mb-4 tw-text-base">
            Select companies to view detailed workforce analytics and insights.
          </p>
          <!-- if we're mobile, show the add company button -->
          <div class="tw-flex @md:tw-hidden">
            <button
              mat-stroked-button
              color="primary"
              (click)="openCompanyEditorModal()"
              class="@md:tw-ml-3 tw-mt-3 @md:tw-mt-0 tw-w-fit tw-min-w-fit">
              <span class="tw-flex tw-items-center tw-gap-2 tw-text-nowrap">
                <mat-icon class="tw-text-base tw-w-[18px]">add</mat-icon>
                Add Company
              </span>
            </button>
          </div>
        </div>

        <!-- Company mode (In-Depth) -->
        <app-in-depth-dashboard
          *ngIf="mode === 'company' && selectedCompanyIds.size > 0"
          [quickBuild]="quickBuild"
          [dateRangeStrings]="dateRangeStrings"
          [reportTarget]="reportTarget"
          [chartConfigs]="chartConfigs"
          (configChange)="onChartConfigChange($event.chartId, $event.config)"></app-in-depth-dashboard>

        <!-- Battle mode (Head-to-Head) -->
        <app-head-to-head-dashboard
          *ngIf="mode === 'battle' && selectedCompanyIds.size > 0"
          [companyBattleQBs]="companyBattleQBs"
          [dateRangeStrings]="dateRangeStrings"
          [reportTarget]="reportTarget"
          [chartConfigs]="chartConfigs"
          (configChange)="onChartConfigChange($event.chartId, $event.config)"></app-head-to-head-dashboard>

        <!-- Benchmark mode -->
        <div *ngIf="mode === 'benchmark' && benchmarkCompanyQBs.length > 0">
          <app-benchmark-dashboard
            [benchmarkQuickBuilds]="benchmarkCompanyQBs"
            [dateFrom]="dateRangeStrings[0]"
            [dateTo]="dateRangeStrings[1]"
            [reportTarget]="reportTarget"
            [selectedJobFunctions]="selectedJobFunctions"
            [selectedLevels]="selectedJobLevels"
            [selectedRoles]="selectedRole ? [selectedRole.name] : undefined">
          </app-benchmark-dashboard>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<tour-step-template></tour-step-template>

<!-- REUSABLE TEMPLATES -->
<!-- filter chips -->
<ng-template #filterChipsTemplate>
  <span
    *ngIf="activeFilterCount > 0"
    class="tw-bg-[#102825] tw-text-[#7FFFD4] tw-px-4 tw-py-1 tw-rounded-full tw-text-base tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-[#1e3a34] tw-flex-shrink-0">
    <mat-icon inline style="font-size: 1.2em;">filter_list</mat-icon>
    {{ activeFilterCount }} Filter{{ activeFilterCount > 1 ? 's' : '' }}
  </span>

  <span
    *ngIf="activeFilterCount < 1 || !activeFilterCount"
    class="tw-bg-gray-800 tw-text-gray-300 tw-px-4 tw-py-1 tw-rounded-full tw-text-base tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-gray-700 tw-flex-shrink-0">
    <mat-icon inline style="font-size: 1.2em;">filter_list</mat-icon>
    Filters
  </span>
</ng-template>

<!-- company list editor dialog used by both modes (company and battle) -->
<ng-template #companyEditorDialog>
  <h2 mat-dialog-title class="tw-pb-0">Edit Companies</h2>
  <button
    mat-icon-button
    (click)="closeCompanyEditorModal()"
    class="tw-absolute tw-top-1 tw-right-1 tw-text-dark-light-dynamic">
    <mat-icon>close</mat-icon>
  </button>
  <div class="tw-p-0">
    <app-company-list-editor
      [multiSelect]="selectMultipleCompanies"
      [initialActiveList]="activeList"
      (activeListChange)="onActiveListChange($event)"
      [initialSelectedCompanyIds]="selectedCompanyIds"
      (selectedCompaniesChange)="onSelectedCompaniesChange($event)"></app-company-list-editor>
  </div>
</ng-template>

<!-- filter controls -->
<ng-template #filterControlsTemplate>
  <app-job-function-dropdown
    [multiSelect]="true"
    [preSelectedJobFunctions]="selectedJobFunctions"
    (jobFunctionSelectionChanged)="onJobFunctionSelectionChanged($event)"
    [ngClass]="{ 'active-filter': isJobFunctionFilterActive }"></app-job-function-dropdown>

  <app-job-level-dropdown
    [multiSelect]="true"
    [preSelectedJobLevels]="selectedJobLevels"
    (jobLevelSelectionChanged)="onJobLevelSelectionChanged($event)"
    [ngClass]="{ 'active-filter': isJobLevelFilterActive }"></app-job-level-dropdown>

  <app-role-dropdown
    [preSelectedRole]="selectedRole"
    (roleSelected)="onRoleSelect($event)"
    [ngClass]="{ 'active-filter': isRoleFilterActive }"
    class="tw-flex-1"></app-role-dropdown>
</ng-template>

<!-- company name display -->
<ng-template #companyDisplay let-isMobile="isMobile">
  <!-- company mode -->
  <div
    *ngIf="mode === 'company' && quickBuild?.name"
    [ngClass]="{
      'tw-text-lg @lg:tw-text-xl @xl:tw-text-2xl tw-items-center tw-hidden @sm:tw-flex': !isMobile,
      'tw-text-lg @lg:tw-text-xl @xl:tw-text-2xl tw-items-center tw-flex @md:tw-hidden': isMobile
    }">
    <ng-container *ngIf="isMobile; else desktopCompany">
      <a
        (click)="openCompanyEditorModal()"
        class="hover:tw-underline tw-flex tw-items-center tw-gap-1">
        {{ quickBuild?.name }}
        <button mat-icon-button>
          <mat-icon class="tw-text-[20px] tw-leading-[20px]">edit</mat-icon>
        </button>
      </a>
    </ng-container>
    <ng-template #desktopCompany>
      {{ quickBuild?.name }}
    </ng-template>
  </div>

  <!-- battle mode -->
  <div
    *ngIf="(mode === 'battle' || mode === 'benchmark') && battleModeDisplayNames"
    class="tw-flex tw-items-center"
    [ngClass]="{
      '@md:tw-text-lg @lg:tw-text-xl @xl:tw-text-2xl tw-hidden @sm:tw-flex': !isMobile,
      'tw-text-lg @md:tw-hidden tw-mt-4': isMobile
    }">
    <ng-container *ngIf="isMobile; else desktopBattle">
      <a
        (click)="openCompanyEditorModal()"
        class="hover:tw-underline tw-flex tw-items-center tw-gap-1">
        {{ battleModeDisplayNames }}
        <button mat-icon-button>
          <mat-icon class="tw-text-[20px] tw-leading-[20px]">edit</mat-icon>
        </button>
      </a>
    </ng-container>
    <ng-template #desktopBattle>
      <span>{{ battleModeDisplayNames }}</span>
    </ng-template>

    <button
      *ngIf="remainingCompaniesCount > 0"
      [matMenuTriggerFor]="remainingCompaniesMenu"
      class="tw-min-w-[80px] tw-ml-2 tw-bg-gray-700 hover:tw-bg-gray-600 tw-text-gray-200 tw-px-2.5 tw-py-1 tw-text-sm tw-font-medium tw-rounded-full tw-transition-colors tw-flex-shrink-0 tw-h-7"
      aria-label="More companies">
      + {{ remainingCompaniesCount }} more
    </button>
    <mat-menu
      #remainingCompaniesMenu="matMenu"
      class="battle-mode-company-name-menu tw-translate-y-1">
      <ul class="tw-list-disc tw-list-inside tw-px-4 tw-py-2 tw-my-0">
        <li
          *ngFor="let companyName of remainingCompanyNames"
          class="tw-py-1 tw-text-sm tw-text-gray-200">
          {{ companyName }}
        </li>
      </ul>
    </mat-menu>
  </div>
</ng-template>

<!-- shared dropdown menu for mobile filter chips -->
<mat-menu #filtersMenu="matMenu" class="mobile-filters-menu" [hasBackdrop]="true">
  <div class="tw-flex tw-flex-col tw-gap-y-8 tw-pt-8" (click)="$event.stopPropagation()">
    <button
      mat-icon-button
      class="tw-absolute tw-top-2 tw-right-2 tw-z-10 tw-text-black-white-dynamic"
      (click)="filtersMenuTrigger.closeMenu()">
      <mat-icon>close</mat-icon>
    </button>
    <ng-container class="tw-mt-8" *ngTemplateOutlet="filterControlsTemplate"></ng-container>
  </div>
</mat-menu>
